import React from "react";
import {
  Box,
  Flex,
  Avatar,
  Link as ChakraLink,
  Text,
  Divider,
  VStack,
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
} from "@chakra-ui/react";
import { Link, useHistory } from "react-router-dom";
import { ReactComponent as DonateWhiteIcon } from "../../assets/icons/donate-white.svg";
import Translate from "../LanguageTranslation/Translate";
import AuthModal from "../AuthModal";

function SidebarFooter({
  logoutAndClear,
  isUserLoggedIn,
  isSidebarOpen,
  username,
  email,
  colorMode,
  popoverLinks,
  openAuthModal,
  redirectPath,
  isOpen,
  onClose,
}) {
  const history = useHistory();

  return (
    <>
      {isUserLoggedIn && (
        <Box
          p={isSidebarOpen ? 4 : 4}
          pb={isSidebarOpen ? 2 : 2}
          pl={isSidebarOpen ? 3 : 0}
          pt={isSidebarOpen ? 8 : 8}
          flexShrink={0}
          // borderTop="1px"
          // borderColor="blackAlpha.200"
        >
          {isSidebarOpen && (
            <Flex align="center" justifyContent="center" mb={4}>
              <Button
                leftIcon={<DonateWhiteIcon width="24px" height="24px" />}
                as={Link}
                to="/offset-your-carbon-footprint"
                bg="#286328"
                color="white"
                size="sm"
                transition="transform 0.3s"
                _hover={{
                  transform: "scale(1.1)",
                }}
                width="80%"
              >
                <Translate text="Contribute" />
              </Button>
            </Flex>
          )}
          <Flex align="center" justifyContent="center" p={2}>
            <Popover>
              <PopoverTrigger>
                <Flex alignItems="center" cursor="pointer">
                  <Avatar
                    name={username}
                    src="https://bit.ly/broken-link"
                    size="sm"
                    bg="#286328"
                    color="white"
                    pt="2px"
                  />
                  {isSidebarOpen && (
                    <Box ml={2}>
                      <Text fontWeight="bold" mb={0} ml={2}>
                        {username}
                      </Text>
                    </Box>
                  )}
                </Flex>
              </PopoverTrigger>
              <PopoverContent
                bg={colorMode === "light" ? "white" : "gray.700"}
                borderRadius="xl"
                borderColor={colorMode === "light" ? "gray.200" : "gray.600"}
                boxShadow="2xl"
                w="100%"
                height="auto"
                overflowY="hidden"
                color={colorMode === "light" ? "gray.800" : "gray.200"}
                ml={4}
              >
                <PopoverArrow />
                <Flex direction="column">
                  <Box mb={1} p={4} pt={2} pb={2}>
                    <Text fontSize="sm" color="gray.500" mb={0}>
                      {email}
                    </Text>
                  </Box>
                  <Divider mt={0} mb={0} />
                  <VStack align="left" spacing={1} mt={2}>
                    {popoverLinks.map((link, index) => (
                      <ChakraLink
                        as={Link}
                        key={index}
                        to={link.to}
                        p={1}
                        pl={4}
                        pr={4}
                        fontSize="sm"
                        fontWeight="normal"
                        w="100%"
                        _hover={{ bg: "blackAlpha.50" }}
                        position="relative"
                      >
                        <Flex align="center">
                          {link.icon && <Box as={link.icon} mr={2} />}
                          <Translate text={link.text} />
                          {(link.to === "/subscriptions" ||
                            link.to === "/switch-appearance") && (
                            <Box
                              position="absolute"
                              top={-1} // Adjust to move "Soon" slightly above
                              right={1} // Adjust for horizontal position
                              bg="#1A202C" // Background color for the Soon tag
                              color="white"
                              fontSize="10px"
                              px={2}
                              py={0.5}
                              borderRadius="lg"
                              display="inline"
                            >
                              <Translate text="SOON" />
                            </Box>
                          )}
                        </Flex>
                      </ChakraLink>
                    ))}
                    <Divider mt={0} mb={0} />
                    <Text
                      p={1}
                      pl={4}
                      pr={4}
                      w="100%"
                      fontSize="sm"
                      fontWeight="normal"
                      onClick={logoutAndClear}
                      cursor="pointer"
                      _hover={{ bg: "blue.100", color: "blue.800" }}
                    >
                      <Translate text="Logout" />
                    </Text>
                  </VStack>
                </Flex>
              </PopoverContent>
            </Popover>
          </Flex>
        </Box>
      )}
      {!isUserLoggedIn && (
        <Box
          p={isSidebarOpen ? 4 : 4}
          pb={isSidebarOpen ? 2 : 2}
          pl={isSidebarOpen ? 3 : 0}
          pt={isSidebarOpen ? 8 : 8}
          flexShrink={0}
          // borderTop="1px"
          // borderColor="blackAlpha.200"
        >
          {isSidebarOpen && (
            <Flex align="center" justifyContent="center" mb={4}>
             <Button
                leftIcon={<DonateWhiteIcon width="24px" height="24px" />}
                as={Link}
                to="/offset-your-carbon-footprint"
                bg="#286328"
                color="white"
                size="sm"
                transition="transform 0.3s"
                _hover={{
                  transform: "scale(1.1)",
                }}
                width="80%"
              >
                <Translate text="Contribute" />
              </Button>
            </Flex>
          )}
          <Flex align="center" justifyContent="center" p={2}>
            <Popover>
              <PopoverTrigger>
                <Flex alignItems="center" cursor="pointer">
                  <Avatar
                    // name={username}
                    src="https://bit.ly/broken-link"
                    size="sm"
                  />
                  {isSidebarOpen && (
                    <Box ml={2}>
                      <Text fontWeight="bold" mb={0} ml={2}>
                        <Translate text="Login" />
                      </Text>
                    </Box>
                  )}
                </Flex>
              </PopoverTrigger>
              <PopoverContent
                bg={colorMode === "light" ? "white" : "gray.700"}
                borderRadius="xl"
                borderColor={colorMode === "light" ? "gray.200" : "gray.600"}
                boxShadow="2xl"
                w="130%"
                height="auto"
                overflowY="hidden"
                color={colorMode === "light" ? "gray.800" : "gray.200"}
                ml={4}
              >
                <PopoverArrow />
                <Flex direction="column">
                  <Box mb={1} p={4} pt={2} pb={0}>
                    <Button
                      bg="#286328"
                      _hover="none"
                      textColor="white"
                      borderRadius="xl"
                      w="100%"
                      fontSize="sm"
                      fontWeight="normal"
                      onClick={() => openAuthModal("/ai-travel-planner")}
                    >
                      <Translate text="Login" />
                    </Button>
                    <Divider mb={0} />
                  </Box>

                  <VStack align="left" spacing={1} mt={2}>
                    <Text
                      p={1}
                      pl={4}
                      pr={4}
                      w="100%"
                      fontSize="sm"
                      fontWeight="normal"
                      onClick={() => history.push("/policies/terms-of-service")}
                      cursor="pointer"
                      _hover={{ bg: "blue.100", color: "blue.800" }}
                    >
                      <Translate text="Terms of Services" />
                    </Text>
                  </VStack>
                </Flex>
              </PopoverContent>
            </Popover>
          </Flex>
          <AuthModal
            isOpen={isOpen}
            onClose={onClose}
            redirectPath={redirectPath}
          />
        </Box>
      )}
    </>
  );
}

export default SidebarFooter;
